// extracted by mini-css-extract-plugin
module.exports = {"close":"Close_close__LLZq-","btn":"Close_btn__3afbJ"};